import React, { Component } from 'react';
import {Helmet} from 'react-helmet';
import ReactTable from "react-table";
import store from '../helpers/store'
import cellHeaderHOC from '../components/common/Datagrid/CellHeaderHOC';

import { connect } from 'react-redux';
import { debounce, find, findIndex, isEqual, cloneDeep, map } from 'lodash';
import { withRouter } from 'react-router';

import Box from '../components/common/Box';
import { PieChart } from '../components/widgets/charts/types';
import DoughnutChart from '../components/widgets/charts/types/DoughnutChart';
import FieldSelector from '../components/common/Datagrid/FieldsSelector';
import PageFilter from '../components/common/Datagrid/PageFilter';
import EntityFilter from '../components/common/EntityFilter';
import EntityFilterSwitcher from '../components/common/EntityFilterSwitcher';
import EntityFilterButton from '../components/widgets/entityFilter/EntityFilterButton';
import SectionHeader from '../components/common/Datagrid/SectionHeader';
import FieldsSelectorHelper from '../components/common/Datagrid/FieldsSelectorHelper';
import StreamsStats from '../components/common/Stats/Streams';
import TerritoryStats from '../components/common/Stats/Territory';
import CSV from '../helpers/CSVExport';
import LoadingMessage from '../helpers/LoadingMessage';
import CatalogOverview from '../components/widgets/catalog/CatalogOverview';
import ModeSelect from '../components/common/ModeSelect';
import ExportModal from '../components/common/ExportModal';

import { imprintsActions } from '../data/actions/imprints';
import { imprintsFormatter } from '../data/formatters/imprints'
import { imprintsSettings } from '../components/pages/imprints/Settings'
import { filterActions } from '../data/actions/filter';
import DropdownMenu from '../components/common/DropdownMenu';

var manageSvg = require('!svg-inline-loader!../../public/img/manage.svg');
var pieSvg = require('!svg-inline-loader!../../public/img/pie.svg');
var tableSvg = require('!svg-inline-loader!../../public/img/table.svg');
var worldSvg = require('!svg-inline-loader!../../public/img/world.svg');
var lineSvg = require('!svg-inline-loader!../../public/img/line.svg');
var downloadSvg = require('!svg-inline-loader!../../public/img/download.svg');
const CellHeaderTable = cellHeaderHOC(ReactTable);

class Imprints extends Component {

    defaultPageSize = 10;

    constructor(props) {
        super(props)
        const savedFilter = null;
        const filtered = [
          {id: 'im.name', value: ''}, 
          {id: 'imprints', value: this.getPageFilterInitial(savedFilter, 'imprints') },
          {id: 'exclude_imprints', value: this.getPageFilterInitial(savedFilter, 'exclude_imprints')},
          {id: 'track_artists', value: this.getPageFilterInitial(savedFilter, 'artists')},
          { id: "exclude_track_artists", value: this.getPageFilterInitial(savedFilter, "exclude_artists") },
          {id: 'products', value: this.getPageFilterInitial(savedFilter, 'products')},
          {id: 'exclude_products', value: this.getPageFilterInitial(savedFilter, 'exclude_products')},
          {id: 'projects', value: this.getPageFilterInitial(savedFilter, 'projects')},
          {id: 'exclude_projects', value: this.getPageFilterInitial(savedFilter, 'exclude_projects')},          
          {id: 'tracks', value: this.getPageFilterInitial(savedFilter, 'tracks')},
          {id: 'exclude_tracks', value: this.getPageFilterInitial(savedFilter, 'exclude_tracks')}
        ];
        this.state = {
            data: [],
            total: {},
            pages: -1,
            page: 0,
            //pageSize: 10,
            filtered: '',
            filter: { // will be set from FieldsSelector
                columns: this.getInitialFilter(),
                filtered
            },
            basic: true,
            defaultSorted: [{id: 'curr_units', desc: true}],
            view: 'table',
            sources: {"Main": false, "Stream": false, "Video": false, "Radio": false, "Download": false, "Social Creates": false, "Social Views": false},
            currentlyHighlightedSource: null,
            initialCall: true
        }

        this.setFilter = this.setFilter.bind(this);
        this.setView = this.setView.bind(this);
        this.setSearch = this.setSearch.bind(this);
        this.loadData = this.loadData.bind(this);
        this.setFilterSearch = this.setFilterSearch.bind(this);
        this.setFilterSearchDeb = debounce(this.setFilterSearch, 1000);
        this.dispatchLoadData = this.dispatchLoadData.bind(this);
        this.addToImprintsFilter = this.addToImprintsFilter.bind(this);
        this.expandSource = this.expandSource.bind(this);
        this.tableScrollTop = 0;
        this.exportToCsv = this.exportToCsv.bind(this);
        this.exportToCsvFull = this.exportToCsvFull.bind(this);
        this.changeHighlightedSource = this.changeHighlightedSource.bind(this);
        this.checkEntityFilter = this.checkEntityFilter.bind(this);
        this.isAnyFilterApplied = this.isAnyFilterApplied.bind(this);
    }

    componentDidMount() {
        const { history } = this.props;
        if (history.action !== 'POP') {
            this.checkEntityFilter(this.props);
        }
    }

    getInitialFilter() {
        return FieldsSelectorHelper.getInitialFilter(imprintsSettings.settingsForTable());
    }

    getPageSize() {
        return this.props.filter.global ? this.props.filter.global.limit : this.defaultPageSize;
    }

    loadData(state, instance) {
        if(this.state.initialCall) {
            this.setState({initialCall: false})
        } else {
            this.setState({
                sorted: state.sorted
            }, ()=>this.dispatchLoadData(state));            
        }        
    }
    

    dispatchLoadData(state){
        const { dispatch } = this.props;
        const { basic, filter: {columns} } = this.state;
        if(!this.props.filter.entityFilterInitialized)
            return;
        if(this.props.imprints.loading) {
            return;    
        }
         
        const queryColumns = columns.filter(c=>!c.includes('.'));    

        dispatch(imprintsActions.getImprints({
            page: state.page,
            //pageSize: state.pageSize,
            sorted: state.sorted,
            filtered: state.filtered
        }, basic ? true : queryColumns));
    }
    
    checkFilterIDs(nextProps, filterKey, valueKey) {
        if(nextProps.filter[filterKey]) {
            const newFilter = this.getPageFilter(nextProps, filterKey);
            return newFilter;
            
            const existingFilter = find(this.state.filter.filtered, {id:valueKey}).value;
            if(!isEqual(newFilter, existingFilter)){
                //this.setFilterSearch(newFilter, valueKey);
                return newFilter;
            }
        }
        return null;
    }
    
    checkEntityFilter(nextProps){
        const filterKeys = [
            {filter: 'imprints', value: 'imprints'},
            {filter: 'artists', value: 'track_artists'},
            {filter: 'products', value: 'products'},
            {filter: 'projects', value: 'projects'},
            {filter: 'tracks', value: 'tracks'}
        ];        
    
        let newFilterOptions = cloneDeep(this.state.filter.filtered);
        
        for(let filterKey of filterKeys) {
            for(let prefix of ['', 'exclude_']) {
                let filtered = find(newFilterOptions, option=>option.id == prefix+filterKey.value);
                let newValue = this.checkFilterIDs(nextProps, prefix+filterKey.filter, prefix+filterKey.value);
                if(newValue)
                    filtered.value = newValue; 
            }
        }
        
        if(!isEqual(this.state.filter.filtered, newFilterOptions) || (this.props.filter.entityFilterInitialized != nextProps.filter.entityFilterInitialized && nextProps.filter.entityFilterInitialized)) {
            this.setState({
                ...this.state,
                filter: {
                    ...this.state.filter,
                    filtered: newFilterOptions
                }
            }, ()=>{
                let state = Object.assign({}, this.state);
                state.filtered = state.filter.filtered;
                this.dispatchLoadData(state)
            });
        }
    }

    componentWillReceiveProps(nextProps){
        const filterKeys = [
            {filter: 'imprints', value: 'imprints'},
            {filter: 'artists', value: 'track_artists'},
            {filter: 'products', value: 'products'},
            {filter: 'projects', value: 'projects'},
            {filter: 'tracks', value: 'tracks'}
        ];
        if(nextProps.imprints && nextProps.imprints.items){
            this.setState({
                data: nextProps.imprints.items,
                total: nextProps.imprints.totalRow,
                pages: Math.ceil(nextProps.imprints.total / this.getPageSize()),
                loaded: true
            })
        }
        if(nextProps.filter){
            if(nextProps.filter.global){
                if(this.props.filter.global!==undefined && !isEqual(nextProps.filter.global, this.props.filter.global)) {
                    let state = Object.assign({}, this.state);
                    state.filtered = state.filter.filtered;
                    this.dispatchLoadData(state);
                }
                // condition?
                /*
                this.setState({
                    pageSize: nextProps.filter.global.limit
                });
                */
            }
            
            this.checkEntityFilter(nextProps);
        }
    }

    getPageFilter(props, entity){
        let ids = [];
        if(props.filter[entity])
            ids = props.filter[entity].map(item=>item.id);
        return ids;
    }
    
    getPageFilterInitial(savedFilter, entity){
        let favHide = 'favorite';
        if(entity.startsWith('exclude_')) {
            favHide = 'hidden';
            entity = entity.replace('exclude_', '');
        }

        
        let ids = [];
        
        if(savedFilter && Array.isArray(savedFilter.entities)) {
            const entities = savedFilter.entities.filter(item=>(item.entity_type == entity && item.fav_hide == favHide));
            ids = entities.map(item=>item.entity_id);
        }
        return ids;
    }

    setFilter(filter){
        this.setState({
            filter
        })
    }

    setFilterSearch(value, id){
        let filtered = this.state.filter.filtered.slice(0),
            valueIndex = findIndex(filtered, {id});

        if(valueIndex!==-1){
            filtered[valueIndex] = {id, value};
        }
        else {
            filtered.push({id, value})
        }

        this.setState({
            ...this.state,
            filter: {
                ...this.state.filter,
                filtered
            }
        }, ()=>{
            let filterState = cloneDeep(this.state);
            filterState.filtered = filterState.filter.filtered;
            this.dispatchLoadData(filterState);
        });
    }

    setSearch(e){
        const value = e.target.value;
        this.setState({
            filtered: value
        })
        this.setFilterSearchDeb(value, 'im.name')
    }

    renderToolbar(){
        let toolbar = [];
        const dropdownHeader = <span key="settings" className="manage-columns-title">
            Manage Columns
        </span>

        const options = [
            {icon: tableSvg, value: 'table', label: "Table"},
            {icon: pieSvg, value: 'chart', label: "Donut Chart"},
            {icon: lineSvg, value: 'line', label: "Line Chart"},
            {icon: worldSvg, value: 'map', label: "World Map"},
        ];

        toolbar.push(<div className="ibox-action-wrapper" key="ibox">
            <div className="ibox-icon-holder mode-select catalog-select">
                <ModeSelect options={options} selected={this.state.view} onChange={this.setView} isSearchable={ false } />
            </div>
            <div className="manage-columns-holder">
                <DropdownMenu header={dropdownHeader}>
                    <div key="settings-box">
                        <FieldSelector settings={imprintsSettings.settingsForTable(this.state.filter.columns, this.addToImprintsFilter, this.state.sources, this.expandSource)} current={this.state.filter} initial={this.getInitialFilter} onUpdate={this.setFilter} extraClassName="catalog-field-selector" />
                    </div>
                </DropdownMenu>
            </div>
        </div>)

        return toolbar;
    }

    setView(view){
        this.setState({
            view
        })
    }

    addToImprintsFilter(imprint){
        this.props.history.push('/imprints/${imprint.id}');
    }
    
    isAnyFilterApplied() {
        const { filter } = this.state;
        if(!Array.isArray(filter.filtered))
            return false;
        for(let { value } of filter.filtered) {
            if(Array.isArray(value)) {
                if( value.length > 0)
                   return true;
            }
            else if(value)
                return true;
        }
        return false;
    }


    exportToCsv(){
        const { sorted, defaultSorted } = this.state;
        const sortField = (Array.isArray(sorted) && sorted.length > 0) ? sorted[0] : defaultSorted[0];
        const filename = CSV.CSVHeader('imprints', sortField.id, this.props.filter.global);
        let data = CSV.expandTrends(this.state.data);
        data = CSV.filterColumns(data, this.state.filter.columns, this.getInitialFilter());

        return CSV.CSVExport(data, {filename}, 'imprints');
    }
    
    exportToCsvFull(){
        const { dispatch } = this.props;
        const { basic } = this.state;
        if(!this.props.filter.entityFilterInitialized)
            return;
        if(this.props.imprints.loading) {
            return;    
        }
        dispatch(imprintsActions.getImprints({
            page: 0,
            pageSize: 500000,
            sorted: this.state.filter.sorted,
            filtered: this.state.filter.filtered
        }, basic)).then(data=>{
            const { sorted, defaultSorted } = this.state;
            const sortField = (Array.isArray(sorted) && sorted.length > 0) ? sorted[0] : defaultSorted[0];
            const filename = CSV.CSVHeader('imprints', sortField.id, this.props.filter.global);
            data = CSV.expandTrends(data);
            data = CSV.filterColumns(data, this.state.filter.columns, this.getInitialFilter());
            return CSV.CSVExport(data, {filename}, 'imprints');
        })
    }

    
    expandSource(source, event) {
        if(event) {
            event.preventDefault();
            event.stopPropagation();
        }
        let sources = Object.assign({}, this.state.sources);
        sources[source] = !sources[source];
        let { basic } = this.state;
        let refreshCall = ()=>Promise.resolve();
        if(basic) {
            let state = Object.assign({}, this.state);
            state.filtered = state.filter.filtered;            
            refreshCall = ()=>this.dispatchLoadData(state);
        }
        this.setState({
            sources,
            basic: false
        }, ()=>refreshCall());
    }

    changeHighlightedSource(source) {
        if (source != this.state.currentlyHighlightedSource) {
            this.setState({currentlyHighlightedSource: source});
        }
    }

    renderExportToCsv(loading) {
        const currentUser = this.props.user.user;
        const showModal = this.isAnyFilterApplied() && currentUser.allow_full_reports;

        return showModal ? (
            <ExportModal 
                exportTotals={this.exportToCsv}
                exportBreakdown={this.exportToCsvFull}
                loading={loading}
                totalsLabel="Current Page"
                breakdownLabel="Full Data"
            />    
        ) 
        : (
            <a key="download" title="Export CSV" onClick={this.exportToCsv} className="download-link" dangerouslySetInnerHTML={{__html: downloadSvg}} />
        )
    }

    render() {
        const { loaded } = this.state;
        const { entityFilterInitialized } = this.props.filter;
        
        let tableData = this.state.data,
            ids = [];
            
        if(!entityFilterInitialized)
            tableData = [];

        if(tableData.length)
            ids = tableData.filter(item=>item.id).map(item=>item.id);

        const extraFilterBlock = <React.Fragment>
            <h2 className='box-title big-title'>Imprints</h2>
            {!this.props.imprints.loading && <div className="section-filter">
                <div className="page-filter-holder">
                    {/*<EntityFilterSwitcher loaded={loaded} entity="imprints" label="Imprints" />*/}
                    <EntityFilterButton />
                </div>
            </div>}
        </React.Fragment>
        
        const noDataMessage = entityFilterInitialized ? 'No results found. Please check your filters.' : 'Please create or a select a filter, or choose to load the entire catalog.';

        return (
            <div>

            <div className="">
                <Box title="Imprints" extraFilterBlock={extraFilterBlock} toolbar={this.renderToolbar()} className={`catalogue-section-holder ${this.state.view == 'line' ? 'line-chart' : ''}`} exportToCsv={this.renderExportToCsv(this.props.imprints.loading)}>

                    {/* <SectionHeader entity="imprints" searchEntity="Imprint" label="Imprints" data={this.state.data} filtered={this.state.filtered} view={this.state.view} onChange={this.setSearch}>
                    </SectionHeader> */}
                    {this.state.view == 'table' && <div>
                        <CellHeaderTable
                            manual
                            loading={this.props.imprints.loading}
                            loadingText={LoadingMessage('catalog')}
                            noDataText={noDataMessage}
                            className='catalogue-table-holder catalogue imprint-table sticky-table'
                            data={tableData}
                            pages={this.state.pages}
                            defaultPageSize={this.getPageSize()}
                            showPageSizeOptions={false}
                            columns={imprintsSettings.settingsForTable(this.state.filter.columns, this.addToImprintsFilter, this.state.sources, this.expandSource, this.state.total)}
                            currentlyHighlightedSource={this.state.currentlyHighlightedSource}
                            changeHighlightedSource={this.changeHighlightedSource}
                            getTheadThProps={(state, rowInfo, column, instance) => {
                                return {
                                    className: state.currentlyHighlightedSource == column.sourceGroup ? 'hovered' : '',
                                    onMouseEnter: (e, handleOriginal) => {                                  
                                        state.changeHighlightedSource(column.sourceGroup);
                                
                                        if (handleOriginal) {
                                            handleOriginal()
                                        }
                                    }
                                }
                            }}
                            getTdProps={(state, rowInfo, column, instance) => {
                                return {
                                    className: state.currentlyHighlightedSource == column.sourceGroup ? 'hovered' : '',                              
                                    onMouseEnter: (e, handleOriginal) => {                                  
                                        state.changeHighlightedSource(column.sourceGroup);
                                        
                                        if (handleOriginal) {
                                            handleOriginal()
                                        }
                                    }
                                }
                            }}
                            getTfootTdProps={(state, rowInfo, column, instance) => {
                                return {
                                    className: state.currentlyHighlightedSource == column.sourceGroup ? 'hovered' : '',                              
                                    onMouseEnter: (e, handleOriginal) => {                                  
                                        state.changeHighlightedSource(column.sourceGroup);
                                       
                                        if (handleOriginal) {
                                            handleOriginal()
                                        }
                                    }
                                }
                            }}
                            defaultSorted={this.state.defaultSorted}
                            defaultSortDesc={true}
                            filtered={this.state.filter.filtered}
                            onFetchData={this.loadData}
                        />
                    </div>}
                    {this.state.view == 'chart' && <div className="table-chart"><DoughnutChart
                        data={imprintsFormatter.formatForPercentageChart(tableData, 'curr_units')}
                        labels={{header: 'Imprints', titleLabel: 'Imprint', valueLabel: 'streams'}}
                    /></div>}
                    {this.state.view == 'line' && <div className="table-chart"><StreamsStats
                        entity="imprints" ids={ids} filtered={this.state.filter.filtered}
                    /></div>}
                    {this.state.view == 'map' && <div className=""><TerritoryStats
                        entity="imprints" ids={ids} expanded={true} filtered={this.state.filter.filtered}
                    /></div>}
                </Box>
                <div className="row">
                    <div className="col-xs-4">

                    </div>
                </div>
            </div>
            <Helmet>
                <title>Imprints - Catalogue Overview</title>
            </Helmet>

            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        imprints: state.imprints,
        filter: state.filter,
        user: state.user
    }
}
export default withRouter(connect(mapStateToProps)(Imprints))
